export default {
  title: "PeriodJp",
  cardTitle: "評価項目設定",
  currentPeriodLabel: "期間",
  headquartersSignature: "本部署名",
  setterLabel: "設定者",
  approverLabel: "承認者",
  evaluationItem: "評価項目",
  evaluationTargetSetting: "評価目標設定",
  personalGoalSetting: "評価対象（個人目標設定）",
  btnDetail: "詳細",
  targetCardText: {
    nameLabel: "目標",
    weight: "ウェイト",
    unit: "単位",
    formula: "計算式",
    calculation: "計算要否",
    targetOrder: "降順・昇順",
    targetDetailName: "月度",
    expectation: "目標",
    accomplished: "実績",
    percent: "進捗",
    plan: "期中計",
    total: "指標(何を、どの水準に)",
    placeholder: "評価項目入力",
    menu: "指標",
    rate: "達成率",
    point: "ポイント",
    unk: "点数",
    reviewItem: "数値結果に対するコメント",
  },
  messageReject:
    "評価項目を差し戻すと、評価項目設定者に戻します。よろしいですか？",
  messageApprove: "評価項目を承認すると、各部署に連携します。よろしいですか？",
};
